import * as React from 'react';

import { FixMeLater } from '../../utils';

export type UnsafeHTMLProps = {
    children: React.ReactNode;
    component?: React.ElementType;
};

export const UnsafeHTML: React.ForwardRefExoticComponent<UnsafeHTMLProps & React.RefAttributes<HTMLElement>> =
    React.forwardRef(function UnsafeHTML(
        props: UnsafeHTMLProps,
        ref: React.ForwardedRef<FixMeLater>
    ): React.JSX.Element | null {
        const { component = 'div', children, ...other } = props;
        if (children == null) {
            return null;
        }
        const Component: React.ElementType = component;
        return <Component ref={ref} dangerouslySetInnerHTML={{ __html: children }} {...other} />;
    });
